<app-card-layout>
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="text-center mb-4">
      <img src="/assets/app/img/brand-icon.png" height="64" alt="Zscaler" />
    </div>
    <div class="text-center lh-125">
      <h5>Create New Password</h5>
      <small class="text-secondary">
        You are setting a new password for
        <strong>{{ admin.email }}</strong> account.
      </small>
    </div>
    <hr class="w-25 my-4" />

    <div class="form-group">
      <label for="password">Password</label>
      <input
        formControlName="password"
        [ngClass]="{
          'is-invalid': isInvalidPassword()
        }"
        type="password"
        class="form-control"
        id="password"
        placeholder="Enter new password&hellip;"
        maxlength="128"
        required
      />
      <div class="invalid-feedback">
        Password is too weak. Please use a stronger password.
      </div>
    </div>

    <div class="form-group">
      <ngb-progressbar
        type="{{ passwordStrength < 4 ? 'danger' : 'success' }}"
        [value]="25 * passwordStrength"
        height="4px"
      >
      </ngb-progressbar>
    </div>
    <ul class="text-muted small pl-3">
      <li *ngIf="passwordFeedback" class="text-danger">
        {{ passwordFeedback }}
      </li>
    </ul>

    <div class="form-group">
      <label for="confirmPassword">Confirm password</label>
      <input
        id="confirmPassword"
        formControlName="confirmPassword"
        [ngClass]="{ 'is-invalid': isInvalidConfirmPassword() }"
        type="password"
        class="form-control"
        placeholder="Enter password again&hellip;"
        maxlength="128"
        required
      />
      <div class="invalid-feedback">
        Password confirmation doesn't match the password.
      </div>
    </div>

    <button type="submit" class="btn btn-primary btn-block">
      Change password
    </button>
  </form>
</app-card-layout>
